(function ($) {
function FitMenu() {
	var menu = [];
	var cur_level = -1;
	var timer_id = null;
	var selectedItems = [];
	var hoveredItems = [];

	function showList(level, parent_id) {
		var container = menu[level];
		if(container) {
			$(container).show();
			$(container).children().filter('ul').each(function () {
				if($(this).attr('data-parent-id') == parent_id)
					$(this).show(200);
				else
					$(this).hide();
			});
		}
	}

	function selectItem(item) {
		if(!item) return false;
		if(selectedItems[cur_level] === item) return true;
		closeMenu(cur_level + 1);
		var item_id = $(item).attr('data-id');
//		console.log('item_id = ' + item_id, '; cur_level = ' + cur_level);
		$(item).siblings('.selected').removeClass('selected');
		$(item).addClass('selected');
		selectedItems[cur_level] = item;
		showList(cur_level + 1, item_id);
	}

	function closeMenu(from_level) {
		for(var i = from_level, len = menu.length; i < len; i++) {
			$(menu[i]).hide();
			$(selectedItems[i]).removeClass('selected');
			selectedItems[i] = null;
		}
	}

	function visitMenu(level) {
		if(cur_level === level) return true;
		cur_level = level;
		if(timer_id) {
			clearTimeout(timer_id);
			timer_id = null;
		}
		if(!selectedItems[level])
			closeMenu(level + 1);
	}

	function leaveMenu() {
		cur_level = -1;
		timer_id = setTimeout(function() {
			if(cur_level < 0) {
				closeMenu(1);
				$(selectedItems[0]).removeClass('selected');
				selectedItems[0] = null;
			}
			timer_id = null;
		}, 1000);
	}

	function clearTimer(level) {
		if(hoveredItems[level].timer_id) {
			clearTimeout(hoveredItems[level].timer_id);
			hoveredItems[level].timer_id = null;
		}
	}

	function itemMouseOver(item, level, delay) {
		if(hoveredItems[level].item === item) return true;

		clearTimer(level);
		hoveredItems[level].item = item;
		if(delay > 0)
			hoveredItems[level].timer_id = setTimeout(function() {
				selectItem(item, level);
			}, delay);
		else
			selectItem(item, level);
	}

	function itemMouseOut(item, level) {
		clearTimer(level);
		hoveredItems[level].item = null;
	}

	function initMenu(container, level) {
		var delay = $(container).attr('data-delay_ms') || 200;

		$(container)
		.on('mouseover', function() {
//			console.log('level ' + level + ': mouseover');
			visitMenu(level);
		})
		.on('mouseleave', function() {
//			console.log('level ' + level + ': mouseleave');
			leaveMenu();
		})
		.on('mouseover', 'li', function() {
//			console.log('level ' + level + ': listitem mouseover');
			visitMenu(level);
			itemMouseOver(this, level, delay);
		})
		.on('mouseout', 'li', function() {
//			console.log('level ' + level + ': listitem mouseout');
			itemMouseOut(this, level);
		});
	};

	this.addMenu = function(container) {
		console.log('Add menu ' + container);
		initMenu(container, menu.length);
		menu.push($(container));
		selectedItems.push(null);
		hoveredItems.push({item: null, timer_id: null});
	};
}

console.log('Run how many fit onload');
$(document).ready(function() {
	console.log('Document loaded');
	var fit_menu = new FitMenu();
	fit_menu.addMenu('div.pan_sizes .lists_container');
	fit_menu.addMenu('div.brands .lists_container');
	fit_menu.addMenu('div.prod_types .lists_container');
	fit_menu.addMenu('div.pal_sizes .lists_container');
});

})(jQuery);